import {
  GET_BULK_PRODUCTS,
  GET_BULK_PRODUCTS_COMPLETED,
  GET_BULK_PRODUCTS_FAILED,
  GET_BULK_PRODUCT,
  GET_BULK_PRODUCT_COMPLETED,
  GET_BULK_PRODUCT_FAILED,
  ADD_BULK_PRODUCT,
  ADD_BULK_PRODUCT_COMPLETED,
  ADD_BULK_PRODUCT_FAILED,
  SEARCH_BULK_PRODUCTS,
  SEARCH_BULK_PRODUCTS_COMPLETED,
  SEARCH_BULK_PRODUCTS_FAILED,
  UPDATE_BULK_PRODUCT,
  UPDATE_BULK_PRODUCT_COMPLETED, UPDATE_BULK_PRODUCT_FAILED,
  DELETE_BULK_PRODUCT,
  DELETE_BULK_PRODUCT_COMPLETED, DELETE_BULK_PRODUCT_FAILED,
  HIDE_DELETE_BULK_PRODUCT_MODAL,
  SHOW_DELETE_BULK_PRODUCT_MODAL,
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  bulkProducts: [],
  bulkProductsLoading: false,
  bulkProductsError: null,
  bulkProduct: null,
  bulkProductLoading: false,
  bulkProductError: null,
  addingBulkProduct: false,
  updatingBulkProduct: false,
  deleteBulkProductModalVisible: false,
  bulkProductToDelete: null,
  bulkProductDeleting: false,
  search: searchDefault,
};

const bulkProductReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_BULK_PRODUCTS: return handleSearch(state, 'search', action.payload);
    case SEARCH_BULK_PRODUCTS_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_BULK_PRODUCTS_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_BULK_PRODUCTS: {
      return {
        ...state,
        bulkProductsLoading: true,
        bulkProducts: [],
        bulkProductsError: null,
      };
    }
    case GET_BULK_PRODUCTS_COMPLETED: {
      return {
        ...state,
        bulkProductsLoading: false,
        bulkProducts: action.payload.data,
      };
    }
    case GET_BULK_PRODUCTS_FAILED: {
      return {
        ...state,
        bulkProductsLoading: false,
        bulkProductsError: action.payload,
      };
    }
    case GET_BULK_PRODUCT: {
      return {
        ...state,
        bulkProductLoading: true,
        bulkProduct: null,
        bulkProductError: null,
      };
    }
    case GET_BULK_PRODUCT_COMPLETED: {
      return {
        ...state,
        bulkProductLoading: false,
        bulkProduct: action.payload,
      };
    }
    case GET_BULK_PRODUCT_FAILED: {
      return {
        ...state,
        bulkProductLoading: false,
        bulkProductError: action.payload,
      };
    }
    case ADD_BULK_PRODUCT: {
      return {
        ...state,
        addingBulkProduct: true,
      };
    }
    case ADD_BULK_PRODUCT_COMPLETED: {
      return {
        ...state,
        addingBulkProduct: false,
      };
    }
    case ADD_BULK_PRODUCT_FAILED: {
      return {
        ...state,
        addingBulkProduct: false,
      };
    }
    case UPDATE_BULK_PRODUCT: {
      return {
        ...state,
        updatingBulkProduct: true,
      };
    }
    case UPDATE_BULK_PRODUCT_COMPLETED: {
      return {
        ...state,
        updatingBulkProduct: false,
      };
    }
    case UPDATE_BULK_PRODUCT_FAILED: {
      return {
        ...state,
        updatingBulkProduct: false,
      };
    }
    case SHOW_DELETE_BULK_PRODUCT_MODAL: {
      return {
        ...state,
        deleteBulkProductModalVisible: true,
        bulkProductToDelete: action.payload,
      };
    }
    case HIDE_DELETE_BULK_PRODUCT_MODAL: {
      return {
        ...state,
        deleteBulkProductModalVisible: false,
        bulkProductToDelete: null,
      };
    }
    case DELETE_BULK_PRODUCT: {
      return {
        ...state,
        bulkProductDeleting: true,
      };
    }
    case DELETE_BULK_PRODUCT_COMPLETED: {
      return {
        ...state,
        bulkProductDeleting: false,
      };
    }
    case DELETE_BULK_PRODUCT_FAILED: {
      return {
        ...state,
        bulkProductDeleting: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default bulkProductReducer;



// WEBPACK FOOTER //
// ./src/BulkProduct/reducer.js